import React, { useState } from 'react'
import { Col, Button } from 'react-bootstrap'
import { TrashFill, Pencil, EnvelopeFill } from 'react-bootstrap-icons'
import Date from '../date'
import Name from '../name'
import MessageButton from '../../user/message-button'
import DeleteButton from '../delete-button'
import EditButton from '../edit-button'
import useCurrentUser from '../../../hooks/use-current-user'
import AccordionIcon from '../../common/accordion-icon'
import Details from './details'

const GoalItem = ({
    goal = {},
}) => {
    const [ isExpanded, setExpanded ] = useState(true)
    const { isAdmin, id: currentUserId } = useCurrentUser()

    const renderButtons = () => {
        if (!isAdmin && currentUserId !== goal.userId ) {
            return null
        }
        return (
            <React.Fragment>
                <MessageButton variant='link' recipientId={goal.userId} subject='About your goal...'><EnvelopeFill /></MessageButton>
                <EditButton variant='link' goal={goal}><Pencil /></EditButton>
                <DeleteButton variant='link' goal={goal}><TrashFill /></DeleteButton>
            </React.Fragment>
        )
    }

    const renderDetails = () => {
        if (!isExpanded) {
            return null
        }
        return (<Details userGoal={goal} />)
    }

    return (
        <div
            style={{
                minHeight: '80px',
                paddingTop: '20px',
                paddingBottom: '20px',
                paddingLeft: '20px',
                paddingRight: '0px',
                borderTop: '1px solid rgb( 201, 230, 253)',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <div 
                    style={{
                        flexGrow: '1',
                        cursor: 'pointer',
                    }}
                    className='ellipsis-truncate align-self-center'
                    onClick={() => setExpanded(!isExpanded)}
                >
                    <AccordionIcon active={isExpanded} />
                    <Name goal={goal} />
                </div>
                {renderButtons()}
            </div>
            {renderDetails()}
        </div>

    )
}

export default GoalItem